// Compiled using marko@4.28.10 - DO NOT EDIT
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry = require("marko/dist/runtime/components/registry"),
    marko_registerComponent = components_registry.r,
    marko_componentType = marko_registerComponent("/wetracker$1.0.0/src/components/effects_editor/effects/templates/filter.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    effect_header_tag = marko_loadTag(require("./components/effect-header")),
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("f8acae"),
    marko_node0 = marko_createElement("div", {
        "class": "control-group horizontal"
      }, "2", null, 2, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "control-group"
        }, null, null, 3)
        .e("div", {
            "class": "control"
          }, null, null, 3)
          .e("div", {
              "class": "label"
            }, null, null, 1)
            .t("Frequency")
          .e("div", {
              id: "freq-slider",
              "class": "slider"
            }, null, null, 0)
          .e("input", {
              type: "text",
              id: "freq-value",
              value: "440"
            }, null, null, 0)
        .e("div", {
            "class": "control"
          }, null, null, 3)
          .e("div", {
              "class": "label"
            }, null, null, 1)
            .t("Q")
          .e("div", {
              id: "Q-slider",
              "class": "slider"
            }, null, null, 0)
          .e("input", {
              type: "text",
              id: "Q-value",
              value: "1"
            }, null, null, 0)
        .e("div", {
            "class": "control"
          }, null, null, 3)
          .e("div", {
              "class": "label"
            }, null, null, 1)
            .t("Gain")
          .e("div", {
              id: "gain-slider",
              "class": "slider"
            }, null, null, 0)
          .e("input", {
              type: "text",
              id: "gain-value",
              value: "0"
            }, null, null, 0)
      .e("div", {
          "class": "control-group"
        }, null, null, 1)
        .e("div", {
            "class": "control"
          }, null, null, 2)
          .e("div", {
              "class": "label"
            }, null, null, 1)
            .t("Filter Type")
          .e("select", {
              id: "filter-type"
            }, null, null, 7)
            .e("option", {
                value: "lowpass",
                selected: true
              }, null, null, 1)
              .t("LowPass")
            .e("option", {
                value: "highpass"
              }, null, null, 1)
              .t("HighPass")
            .e("option", {
                value: "lowshelf"
              }, null, null, 1)
              .t("LowShelf")
            .e("option", {
                value: "highshelf"
              }, null, null, 1)
              .t("HighShelf")
            .e("option", {
                value: "peaking"
              }, null, null, 1)
              .t("Peaking")
            .e("option", {
                value: "notch"
              }, null, null, 1)
              .t("Notch")
            .e("option", {
                value: "allpass"
              }, null, null, 1)
              .t("AllPass");

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", {
      "class": "effect-control-panel",
      "data-chain-index": "" + data.location.index
    }, "0", component);

  effect_header_tag({
      name: "Filter"
    }, out, __component, "1");

  out.n(marko_node0, component);

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
